// ========================================
// Calendar Filters
// Manages calendar filtering functionality
// ========================================

const CalendarFilters = {
    activeFilters: {},

    /**
     * Apply filters to calendar
     */
    applyFilters(calendarInstance, generateEventsCallback) {
        const professorId = document.getElementById('filter-professor')?.value;
        const formationId = document.getElementById('filter-formation')?.value;

        const filters = {};
        if (professorId) filters.professorId = professorId;
        if (formationId) filters.formationId = formationId;

        this.activeFilters = filters;

        const events = generateEventsCallback(filters);

        if (calendarInstance) {
            calendarInstance.removeAllEvents();
            calendarInstance.addEventSource(events);
        }

        // Save filter preferences
        this.saveFilterPreferences(filters);
    },

    /**
     * Get active filters
     */
    getActiveFilters() {
        return { ...this.activeFilters };
    },

    /**
     * Clear all filters
     */
    clearFilters(calendarInstance, generateEventsCallback) {
        this.activeFilters = {};

        // Reset filter UI
        const professorFilter = document.getElementById('filter-professor');
        const formationFilter = document.getElementById('filter-formation');

        if (professorFilter) professorFilter.value = '';
        if (formationFilter) formationFilter.value = '';

        // Refresh calendar
        const events = generateEventsCallback({});

        if (calendarInstance) {
            calendarInstance.removeAllEvents();
            calendarInstance.addEventSource(events);
        }

        // Clear saved preferences
        BrowserState.removeItem('ecpv_calendar_filters');
    },

    /**
     * Save filter preferences to BrowserState
     */
    saveFilterPreferences(filters) {
        if (window.FileStorage) {
            FileStorage.write('ecpv_calendar_filters', filters);
        } else {
            BrowserState.setItem('ecpv_calendar_filters', JSON.stringify(filters));
        }
    },

    /**
     * Load filter preferences from BrowserState
     */
    loadFilterPreferences() {
        const saved = BrowserState.getItem('ecpv_calendar_filters');
        if (saved) {
            try {
                return JSON.parse(saved);
            } catch (e) {
                console.error('Error loading filter preferences:', e);
                return {};
            }
        }
        return {};
    },

    /**
     * Restore filters from preferences
     */
    restoreFilters() {
        const filters = this.loadFilterPreferences();

        const professorFilter = document.getElementById('filter-professor');
        const formationFilter = document.getElementById('filter-formation');

        if (professorFilter && filters.professorId) {
            professorFilter.value = filters.professorId;
        }

        if (formationFilter && filters.formationId) {
            formationFilter.value = filters.formationId;
        }

        this.activeFilters = filters;
        return filters;
    }
};

// Make CalendarFilters globally available
window.CalendarFilters = CalendarFilters;
